export function Copyright(props: any) {
  return (
    <span
      className="text-center text-xs
     leading-9 tracking-tight text-gray-900 dark:text-gray-100"
    >
      {"Copyright © "}
      <a href="#">StylistGPT</a> {new Date().getFullYear()}
      {"."}
    </span>
  );
}
